import React, { useState, useEffect, useRef } from 'react';
import Dropdown from '../../../Components/CustomDropdown/customdropdown';
import { useToast } from '../../../Utils/toastContext';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmContinueButton from '../../../Components/ContinueButton/continue-button';
import AddressAutocomplete from '../../../Components/addressInput/address-input';
import { useNavigate } from 'react-router-dom';
import LabelWithStatus from '../../../Components/onboarding/label-with-status';
import { clearFileIdsRedux } from '../../../Redux/store/userSlice';
import {
  setStepStatus,
  setRejectedFields,
} from '../../../Redux/store/onboardingFormSlice';
import ReviewPopup from '../../../Components/onboarding/review-popup';
import ConfirmResetButton from '../../../Components/ContinueButton/reset-button';
import countriesData from '../../../Data/CountryCodes.json';
const validator = require('validator');

const BusinessUserInfo = ({ setCurrentStep }) => {
  const [loading, setLoading] = useState(false);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const roleName = useSelector((state) => state.user.roleName);
  const dispatch = useDispatch();
  const [mobileNumber, setMobileNumber] = useState('');
  const [selectedCode, setSelectedCode] = useState('+61');
  const navigate = useNavigate();
  const [companyTypeData, setCompanyTypeData] = useState([]);
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const userStatus = useSelector((state) => state.user.userStatus);
  const [email, setEmail] = useState('');
  const [focus, setFocus] = useState(false);
  const [countries, setCountries] = useState([]);
  const [isValidAbn, setIsValidAbn] = useState(false);
  // ABN inline validation: 'idle' | 'checking' | 'valid' | 'invalid'
  const [abnStatus, setAbnStatus] = useState('idle');
  const [abnMessage, setAbnMessage] = useState('');
  const [abnEntityName, setAbnEntityName] = useState('');
  const abnDebounceRef = useRef(null);
  const abnRequestRef = useRef(0);
  const [isValidAcn, setIsValidAcn] = useState(false);
  // ACN inline validation: 'idle' | 'checking' | 'valid' | 'invalid'
  const [acnStatus, setAcnStatus] = useState('idle');
  const [acnMessage, setAcnMessage] = useState('');
  const [websiteStatus, setWebsiteStatus] = useState('idle');
  const [websiteMessage, setWebsiteMessage] = useState('');
  const [acnEntityName, setAcnEntityName] = useState('');
  const acnDebounceRef = useRef(null);
  const acnRequestRef = useRef(0);
  const username = useSelector((state) => state.user.username);

  const [fullName, setfullName] = useState({
    verification_id: null,
    value: username,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [tradingName, setTradingName] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [profilePayloadFile, setProfilePayloadFile] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [abn, setAbn] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [acn, setAcn] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState('/avatar.svg');
  const { showToast } = useToast();
  const [showPopup, setShowPopup] = useState(false);
  const [companyTypeId, setCompanyTypeId] = useState(1);
  const [registeredAddress, setRegisteredAddress] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [registeredAddressApi, setRegisteredAddressApi] = useState('');

  const [principalAddressApi, setPrincipalAddressApi] = useState('');
  const [principalAddress, setPrincipalAddress] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redRegCountry, setRegCountry] = useState(null);
  const [redRegCity, setRegCity] = useState(null);
  const [redRegState, setRegState] = useState(null);
  const [principalCountry, setPrincipalCountry] = useState(null);
  const [principalCity, setPrincipalCity] = useState(null);
  const [principalState, setPrincipalState] = useState(null);
  const rejectedFields = useSelector((state) => state.form.rejectedFields);
  const [companyWebsite, setCompanyWebsite] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [industry, setIndustry] = useState({
    verification_id: null,
    value: null,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [agentName, setAgentName] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [preSelectedCompanyType, setPreSelectedCompanyType] = useState({
    value: 1,
    label: 'Sole Trader',
  });
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Company website: require a real domain. A missing protocol is added on
  // blur so "example.com.au" is stored as "https://example.com.au".
  const getWebsiteError = (raw) => {
    const trimmed = String(raw ?? '').trim();
    if (!trimmed) return '';
    if (/\s/.test(trimmed)) {
      return 'A website address cannot contain spaces.';
    }

    const withProtocol = /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)
      ? trimmed
      : `https://${trimmed}`;

    let parsed;
    try {
      parsed = new URL(withProtocol);
    } catch {
      return 'Enter a valid website, such as example.com.au.';
    }

    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return 'Use a website address that starts with http:// or https://.';
    }

    const host = parsed.hostname.replace(/\.$/, '').toLowerCase();
    const labels = host.split('.');
    const tld = labels[labels.length - 1];
    const labelOk = (label) =>
      /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(label) ||
      /^xn--[a-z0-9-]{1,59}$/i.test(label);
    const isIp = /^\d{1,3}(\.\d{1,3}){3}$/.test(host) || host.includes(':');

    if (
      isIp ||
      labels.length < 2 ||
      !labels.every(labelOk) ||
      !/^[a-z]{2,}$/i.test(tld)
    ) {
      return 'Enter a valid website domain, such as example.com.au.';
    }

    return '';
  };

  const normalizeWebsite = (raw) => {
    const trimmed = String(raw ?? '').trim();
    if (!trimmed || getWebsiteError(trimmed)) return trimmed;
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) return trimmed;
    return `https://${trimmed}`;
  };

  const handleWebsiteBlur = () => {
    const raw = String(companyWebsite.value ?? '').trim();
    if (!raw) {
      setWebsiteStatus('idle');
      setWebsiteMessage('');
      return;
    }
    const error = getWebsiteError(raw);
    if (error) {
      setWebsiteStatus('invalid');
      setWebsiteMessage(error);
      return;
    }
    const normalized = normalizeWebsite(raw);
    setCompanyWebsite((prev) =>
      prev.value === normalized ? prev : { ...prev, value: normalized },
    );
    setWebsiteStatus('idle');
    setWebsiteMessage('');
  };

  const handleWebsiteChange = (value) => {
    setCompanyWebsite({
      ...companyWebsite,
      value,
    });
    if (!String(value ?? '').trim()) {
      setWebsiteStatus('idle');
      setWebsiteMessage('');
      return;
    }
    if (websiteStatus === 'invalid') {
      const error = getWebsiteError(value);
      setWebsiteStatus(error ? 'invalid' : 'idle');
      setWebsiteMessage(error);
    }
  };

  // ---------------------------------------------------------------------
  // ABN validation
  // Runs as the user types (debounced) and again on blur, so the specific
  // problem — format, checksum, or lookup — is reported inline instead of
  // only surfacing on submit.
  // ---------------------------------------------------------------------

  // Official ATO modulus-89 checksum for an 11-digit ABN.
  const isValidAbnChecksum = (value) => {
    const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    const digits = value.split('').map(Number);
    // Subtract 1 from the first digit, then weight and sum all 11 digits.
    const total = digits.reduce(
      (sum, digit, index) =>
        sum + (index === 0 ? digit - 1 : digit) * weights[index],
      0,
    );
    return total % 89 === 0;
  };

  // Returns a specific problem for the format/checksum stage, or null when
  // the value is well-formed enough to be worth a lookup.
  const getAbnLocalError = (cleanedAbn) => {
    if (!cleanedAbn) return 'Please enter your ABN.';
    if (/\D/.test(cleanedAbn))
      return 'An ABN can only contain numbers, so please remove any letters or symbols.';
    if (cleanedAbn.length !== 11)
      return `An ABN must be 11 digits, but you have entered ${cleanedAbn.length}.`;
    if (!isValidAbnChecksum(cleanedAbn))
      return 'That is not a valid ABN, so please check for mistyped digits.';
    return null;
  };

  const runAbnValidation = async (rawValue) => {
    const cleanedAbn = (rawValue ?? '').replace(/\s+/g, '');

    // Nothing entered yet: clear the field rather than showing an error.
    if (!cleanedAbn) {
      setIsValidAbn(false);
      setAbnStatus('idle');
      setAbnMessage('');
      setAbnEntityName('');
      return;
    }

    // Stage 1 - format and checksum, resolved instantly with no network call.
    const localError = getAbnLocalError(cleanedAbn);
    if (localError) {
      setIsValidAbn(false);
      setAbnStatus('invalid');
      setAbnMessage(localError);
      setAbnEntityName('');
      return;
    }

    // Stage 2 - registry lookup. Track the request so a slow earlier
    // response can never overwrite a newer one.
    const requestId = abnRequestRef.current + 1;
    abnRequestRef.current = requestId;

    setAbnStatus('checking');
    setAbnMessage('Checking this ABN with the business register…');
    setAbnEntityName('');

    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/abn-lookup/${cleanedAbn}`,
      );
      if (abnRequestRef.current !== requestId) return; // superseded

      if (response.status == 200) {
        const entityName =
          response.data?.entity_name ||
          response.data?.business_name ||
          response.data?.name ||
          '';
        setIsValidAbn(true);
        setAbnStatus('valid');
        setAbnEntityName(entityName);
        setAbnMessage(
          entityName ? `ABN verified — ${entityName}` : 'ABN verified.',
        );
      } else {
        setIsValidAbn(false);
        setAbnStatus('invalid');
        setAbnEntityName('');
        setAbnMessage(
          response.message ||
            'We could not find this ABN on the business register.',
        );
      }
    } catch (err) {
      if (abnRequestRef.current !== requestId) return; // superseded
      setIsValidAbn(false);
      setAbnStatus('invalid');
      setAbnEntityName('');
      setAbnMessage(
        err.message ||
          'We could not check this ABN right now, so please try again.',
      );
    }
  };

  // Blur validates immediately, cancelling any pending debounce.
  const validateAbn = () => {
    if (abnDebounceRef.current) {
      clearTimeout(abnDebounceRef.current);
      abnDebounceRef.current = null;
    }
    runAbnValidation(abn.value);
  };

  // Typing validates after a short pause, so the lookup does not fire on
  // every keystroke.
  const handleAbnChange = (rawValue) => {
    setAbn((prev) => ({ ...prev, value: rawValue }));
    setIsValidAbn(false);
    setAbnEntityName('');

    if (abnDebounceRef.current) clearTimeout(abnDebounceRef.current);

    const cleanedAbn = (rawValue ?? '').replace(/\s+/g, '');
    if (!cleanedAbn) {
      setAbnStatus('idle');
      setAbnMessage('');
      return;
    }

    // Show format/checksum problems only once the field is full length, so
    // the user is not told "must be 11 digits" while still typing.
    const localError = getAbnLocalError(cleanedAbn);
    if (localError && cleanedAbn.length < 11 && !/\D/.test(cleanedAbn)) {
      setAbnStatus('idle');
      setAbnMessage('');
      return;
    }

    abnDebounceRef.current = setTimeout(() => {
      runAbnValidation(rawValue);
    }, 500);
  };

  // Clear any pending debounce when the component unmounts.
  useEffect(() => {
    return () => {
      if (abnDebounceRef.current) clearTimeout(abnDebounceRef.current);
    };
  }, []);
  // ---------------------------------------------------------------------
  // ACN validation
  // Mirrors the ABN behaviour: validate while typing (debounced) and on
  // blur, reporting the specific problem — format, checksum, or lookup —
  // inline rather than only on submit.
  // ---------------------------------------------------------------------

  // Official ASIC modulus-10 checksum for a 9-digit ACN.
  const isValidAcnChecksum = (value) => {
    const weights = [8, 7, 6, 5, 4, 3, 2, 1];
    const digits = value.split('').map(Number);
    // Weight the first 8 digits; the 9th is the check digit.
    const total = weights.reduce(
      (sum, weight, index) => sum + digits[index] * weight,
      0,
    );
    const remainder = total % 10;
    const checkDigit = (10 - remainder) % 10;
    return checkDigit === digits[8];
  };

  // Returns a specific problem for the format/checksum stage, or null when
  // the value is well-formed enough to be worth a lookup.
  const getAcnLocalError = (cleanedAcn) => {
    if (!cleanedAcn) return 'Please enter your ACN.';
    if (/\D/.test(cleanedAcn))
      return 'An ACN can only contain numbers, so please remove any letters or symbols.';
    if (cleanedAcn.length !== 9)
      return `An ACN must be 9 digits, but you have entered ${cleanedAcn.length}.`;
    if (!isValidAcnChecksum(cleanedAcn))
      return 'That is not a valid ACN, so please check for mistyped digits.';
    return null;
  };

  const runAcnValidation = async (rawValue) => {
    const cleanedAcn = (rawValue ?? '').replace(/\s+/g, '');

    // Nothing entered yet: clear the field rather than showing an error.
    if (!cleanedAcn) {
      setIsValidAcn(false);
      setAcnStatus('idle');
      setAcnMessage('');
      setAcnEntityName('');
      return;
    }

    // Stage 1 - format and checksum, resolved instantly with no network call.
    const localError = getAcnLocalError(cleanedAcn);
    if (localError) {
      setIsValidAcn(false);
      setAcnStatus('invalid');
      setAcnMessage(localError);
      setAcnEntityName('');
      return;
    }

    // Stage 2 - registry lookup. Track the request so a slow earlier
    // response can never overwrite a newer one.
    const requestId = acnRequestRef.current + 1;
    acnRequestRef.current = requestId;

    setAcnStatus('checking');
    setAcnMessage('Checking this ACN with the company register…');
    setAcnEntityName('');

    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/acn-lookup/${cleanedAcn}`,
      );
      if (acnRequestRef.current !== requestId) return; // superseded

      if (response.status == 200) {
        const entityName =
          response.data?.entity_name ||
          response.data?.company_name ||
          response.data?.business_name ||
          response.data?.name ||
          '';
        setIsValidAcn(true);
        setAcnStatus('valid');
        setAcnEntityName(entityName);
        setAcnMessage(
          entityName ? `ACN verified — ${entityName}` : 'ACN verified.',
        );
      } else {
        setIsValidAcn(false);
        setAcnStatus('invalid');
        setAcnEntityName('');
        setAcnMessage(
          response.message ||
            'We could not find this ACN on the company register.',
        );
      }
    } catch (err) {
      if (acnRequestRef.current !== requestId) return; // superseded
      setIsValidAcn(false);
      setAcnStatus('invalid');
      setAcnEntityName('');
      setAcnMessage(
        err.message ||
          'We could not check this ACN right now, so please try again.',
      );
    }
  };

  // Blur validates immediately, cancelling any pending debounce.
  const validateAcn = () => {
    if (acnDebounceRef.current) {
      clearTimeout(acnDebounceRef.current);
      acnDebounceRef.current = null;
    }
    runAcnValidation(acn.value);
  };

  // Typing validates after a short pause, so the lookup does not fire on
  // every keystroke.
  const handleAcnChange = (rawValue) => {
    setAcn((prev) => ({ ...prev, value: rawValue }));
    setIsValidAcn(false);
    setAcnEntityName('');

    if (acnDebounceRef.current) clearTimeout(acnDebounceRef.current);

    const cleanedAcn = (rawValue ?? '').replace(/\s+/g, '');
    if (!cleanedAcn) {
      setAcnStatus('idle');
      setAcnMessage('');
      return;
    }

    // Show format/checksum problems only once the field is full length, so
    // the user is not told "must be 9 digits" while still typing.
    const localError = getAcnLocalError(cleanedAcn);
    if (localError && cleanedAcn.length < 9 && !/\D/.test(cleanedAcn)) {
      setAcnStatus('idle');
      setAcnMessage('');
      return;
    }

    acnDebounceRef.current = setTimeout(() => {
      runAcnValidation(rawValue);
    }, 500);
  };

  // Clear any pending debounce when the component unmounts.
  useEffect(() => {
    return () => {
      if (acnDebounceRef.current) clearTimeout(acnDebounceRef.current);
    };
  }, []);
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const fieldLabelMap = {
    country_of_formation_id: 'Country of formation',
    profile_picture: 'Logo',
    /* FIX: agency keys returned by the rejected-fields API. */
    agency_name: 'Full Name',
    agency_type: 'Business Type',
    profile_picture_file: 'Logo',
    business_name: 'Full Name',
    trading_name: 'Trading Name',
    address: "Address of the Company's Registered Office",
    postal_address: 'Postal Address',
    abn: 'ABN',
    acn: 'ACN',
    website: 'Company Website',
    industry: 'Industry',
    contact_person_name: 'Contact Person Name',
    contact_person_phone: 'Contact Person Mobile Number',
    contact_person_email: 'Contact Person Email',
  };
  const handleSelectCompanyType = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setCompanyTypeId(selectedOption.value);
  };
  const checkFields = () => {
    const validations = [
      // {
      //   when: !profilePayloadFile.value,
      //   msg: "Please upload company's logo",
      // },
      {
        when: !principalAddress.value || !principalCountry,
        msg: 'Please enter valid postal address',
      },
      {
        when: !registeredAddress.value || !redRegCountry,
        msg: "Please enter valid address of the company's registered office",
      },

      // ---------- Company Info ----------
      {
        when: !fullName.value,
        msg: 'Please enter full name of the company',
      },

      {
        when:
          !abn.value || (abn.value && abn.value.length != 11) || !isValidAbn,
        msg: 'Please enter a valid 11 digits ABN',
      },
      {
        when: !acn.value || (acn.value && acn.value.length != 9) || !isValidAcn,
        msg: 'Please enter a valid 9 digits ACN',
      },
      {
        when: !String(companyWebsite.value ?? '').trim(),
        msg: 'Please enter the url of the company’s website',
        field: 'website',
      },
      {
        when: !!getWebsiteError(companyWebsite.value),
        msg: getWebsiteError(companyWebsite.value),
        field: 'website',
      },
      {
        when: !industry.value,
        msg: 'Please enter the industry of the company',
      },
      {
        when: !agentName.value,
        msg: 'Please enter the name of the contact person',
      },
      {
        when: !validateEmail(email.value),
        msg: 'Please enter a valid email address',
      },
      {
        when: !mobileNumber.value,
        msg: 'Please enter a valid mobile number',
      },
    ];

    const error = validations.find((v) => v.when);
    if (error) {
      if (error.field === 'website') {
        setWebsiteStatus('invalid');
        setWebsiteMessage(error.msg);
      }
      showToast(error.msg, 'error');
      return true;
    }

    return false;
  };

  const handleContinue = async (isFinal) => {
    if (isFinal) {
      if (!checkFields()) {
        setLoading(true);
        handlesave(isFinal);
      }
    } else {
      setLoading(true);
      handlesave(isFinal);
    }
  };
  const handleBack = () => {};

  const getAllLocationDetailsReg = async () => {
    try {
      const response = await getLocation(
        registeredAddress.value.country &&
          registeredAddress.value.country.name &&
          registeredAddress.value.country.name !== ''
          ? registeredAddress.value.country.name
          : registeredAddress.value.country,
        registeredAddress.value.state &&
          registeredAddress.value.state.name &&
          registeredAddress.value.state.name !== ''
          ? registeredAddress.value.state.name
          : registeredAddress.value.state,
        registeredAddress.value.city &&
          registeredAddress.value.city.name &&
          registeredAddress.value.city.name !== ''
          ? registeredAddress.value.city.name
          : registeredAddress.value.city,
      );
      setRegCountry(response.country_id);
      setRegState(response.state_id);
      setRegCity(response.city_id);
    } catch (err) {
      setRegCountry(null);
      setRegState(null);
      setRegCity(null);
      showToast(err.message, 'error');
    }
  };
  const getAllLocationDetailsPrincipal = async () => {
    try {
      const response = await getLocation(
        principalAddress.value.country &&
          principalAddress.value.country.name &&
          principalAddress.value.country.name !== ''
          ? principalAddress.value.country.name
          : principalAddress.value.country,
        principalAddress.value.state &&
          principalAddress.value.state.name &&
          principalAddress.value.state.name !== ''
          ? principalAddress.value.state.name
          : principalAddress.value.state,
        principalAddress.value.city &&
          principalAddress.value.city.name &&
          principalAddress.value.city.name !== ''
          ? principalAddress.value.city.name
          : principalAddress.value.city,
      );
      setPrincipalCountry(response.country_id);
      setPrincipalState(response.state_id);
      setPrincipalCity(response.city_id);
    } catch (err) {
      setPrincipalCountry(null);
      setPrincipalState(null);
      setPrincipalCity(null);
      showToast(err.message, 'error');
    }
  };

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };

  const resetApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/${roleName}/information/reset`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
        getDetailsWithVerification();
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getEnum = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/business/information/enums`,
      );

      if (response.status == 200) {
        const companyTypeDataDetails = [];
        response.data.business_types.forEach((profile) => {
          companyTypeDataDetails.push({
            value: profile.value,
            label: profile.label,
          });
        });
        setCompanyTypeData(companyTypeDataDetails);
        setPreSelectedCompanyType(companyTypeDataDetails[0]);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setCompanyTypeData([]);
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setCompanyTypeData([]);
    }
  };

  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/${roleName}/information/verification/preview`,
      );

      if (response.status == 200) {
        if (response.data) {
          if (roleName == 'business') {
            setPreSelectedCompanyType({
              value: response.data.business_type.value.id,
              label: response.data.business_type.value.label,
            });
            setCompanyTypeId(response.data.business_type.value.id);
            setfullName(response.data.business_name);
          }
          if (roleName == 'agency') {
            setPreSelectedCompanyType({
              value: response.data.agency_type.value.id,
              label: response.data.agency_type.value.label,
            });
            setCompanyTypeId(response.data.agency_type.value.id);
            setfullName(response.data.agency_name);
          }
          setProfilePayloadFile(response?.data?.profile_picture);
          setPreview(
            response.data?.profile_picture?.value?.presigned_url == ''
              ? '/avatar.svg'
              : response.data?.profile_picture?.value?.presigned_url,
          );
          setTradingName(response.data.trading_name);
          setRegisteredAddressApi(response.data.address.value);
          setRegisteredAddress(response.data.address);
          setPrincipalAddressApi(response.data.postal_address.value);
          setPrincipalAddress(response.data.postal_address);
          setAbn(response.data.abn);
          if (response.data.abn.value) {
            setIsValidAbn(true);
            // Already saved and verified, so show the confirmed state.
            setAbnStatus('valid');
            setAbnMessage('ABN verified.');
          }

          setAcn(response.data.acn);
          if (response.data.acn.value) {
            setIsValidAcn(true);
            // Already saved and verified, so show the confirmed state.
            setAcnStatus('valid');
            setAcnMessage('ACN verified.');
          }
          setCompanyWebsite(response.data.website);
          setIndustry(response.data.industry);
          setAgentName(response.data.contact_person_name);
          setEmail(response.data.contact_person_email);
          setMobileNumber(response.data.contact_person_phone);
        } else {
          setPreSelectedCompanyType({
            value: 1,
            label: 'Sole Trader',
          });
          setCompanyTypeId(1);
          setProfilePayloadFile({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPreview('/avatar.svg');
          setfullName({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setTradingName({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setRegisteredAddressApi({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setRegisteredAddress({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPrincipalAddressApi({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setPrincipalAddress({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAbn({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          // Reset the inline ABN feedback along with the field.
          setIsValidAbn(false);
          setAbnStatus('idle');
          setAbnMessage('');
          setAbnEntityName('');
          setAcn({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          // Reset the inline ACN feedback along with the field.
          setIsValidAcn(false);
          setAcnStatus('idle');
          setAcnMessage('');
          setAcnEntityName('');
          setCompanyWebsite({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setIndustry({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAgentName({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setEmail({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setMobileNumber({
            verification_id: null,
            value: null,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    getEnum();
  }, []);
  useEffect(() => {
    if (
      (registeredAddress.value && registeredAddress.value.country) ||
      (registeredAddress.value && registeredAddress.value.country.name)
    ) {
      getAllLocationDetailsReg();
    }
  }, [registeredAddress]);

  useEffect(() => {
    if (
      (principalAddress.value && principalAddress.value.country) ||
      (principalAddress.value && principalAddress.value.country.name)
    ) {
      getAllLocationDetailsPrincipal();
    }
  }, [principalAddress]);

  useEffect(() => {
    if (stepStatus.length > 0 && stepStatus[0].status != 'DRAFT') {
      getDetailsWithVerification();
    }
  }, [stepStatus]);

  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ['image/png', 'image/jpeg'];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast('Please upload an image in PNG or JPEG format.', 'error');
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast('File size must be less than 10MB.', 'error');
      return;
    }
    if (file) {
      let toastMessage = null;
      setLoading(true);
      try {
        const response = await UploadCSVApi(file);
        if (response.status == '201') {
          toastMessage = {
            message: 'Logo uploaded successfully',
            type: 'success',
          };
          const imageUrl = URL.createObjectURL(file);
          setPreview(imageUrl);
          setProfilePayloadFile({
            ...profilePayloadFile,
            value: response.data,
          });
        }
      } catch (err) {
        setPreview('/avatar.svg');
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }
    event.target.value = '';
  };
  const UploadCSVApi = async (file) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const formData3 = new FormData();
    formData3.append('file', file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: formData3,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI(isFinal);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(2);
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatus(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/api/v1/onboarding/rejected-fields`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              'Information has been saved successfully. Please submit to proceed further.',
            type: 'success',
          };
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const safeValue = (val) => {
    return val === undefined || val === null || val === '' ? null : val;
  };
  const isValidAddress = (addr) => {
    if (!addr || typeof addr !== 'object') return false;

    return (
      addr.address_line_1 ||
      addr.city_id ||
      addr.zip_code ||
      addr.google_address
    );
  };
  const submitApplicationAPI = async (isFinal) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording =
      userStatus == 'onboarding' || userStatus == 'pending' ? true : false;
    let apiUrl = isOnbaording
      ? `${BASE_URL}/api/v1/onboarding/${roleName}/information/submit`
      : `${BASE_URL}/api/v1/onboarding/${roleName}/information/update`;
    let payloadRegAddress = {};
    if (registeredAddressApi != null) {
      payloadRegAddress = {
        address_line_1:
          registeredAddressApi.address_line_1 == null
            ? registeredAddressApi.google_address
            : registeredAddressApi.address_line_1,
        address_line_2:
          registeredAddressApi.address_line_2 == null
            ? null
            : registeredAddressApi.address_line_2,
        city_id:
          registeredAddressApi.city != null
            ? registeredAddressApi.city.id
            : null,
        state_id:
          registeredAddressApi.city != null
            ? registeredAddressApi.city.state_id
            : null,
        country_id: redRegCountry,
        zip_code: registeredAddressApi.zip_code,
        google_address: registeredAddressApi.google_address,
      };
    } else {
      if (registeredAddress.value) {
        payloadRegAddress = {
          address_line_1:
            registeredAddress.value.street == ''
              ? registeredAddress.value.full
              : registeredAddress.value.street,
          address_line_2: registeredAddress.value.route,
          city_id: redRegCity,
          state_id: redRegState,
          country_id: redRegCountry,
          zip_code: registeredAddress.value.zip,
          google_address: registeredAddress.value.full,
        };
      }
    }
    // if (payloadRegAddress && payloadRegAddress.city_id === null) {
    //   showToast(
    //     "Please enter valid address of the company's registered office",
    //     "error",
    //   );
    //   return; // Stop execution if city_id is missing
    // }
    let payloadPrincipalAddress = {};
    if (principalAddressApi != null) {
      payloadPrincipalAddress = {
        address_line_1:
          principalAddressApi.address_line_1 == null
            ? principalAddressApi.google_address
            : principalAddressApi.address_line_1,
        address_line_2:
          principalAddressApi.address_line_2 == null
            ? null
            : principalAddressApi.address_line_2,
        city_id:
          principalAddressApi.city != null ? principalAddressApi.city.id : null,
        state_id:
          principalAddressApi.city != null
            ? principalAddressApi.city.state_id
            : null,
        country_id: principalCountry,
        zip_code: principalAddressApi.zip_code,
        google_address: principalAddressApi.google_address,
      };
    } else {
      payloadPrincipalAddress = {
        address_line_1:
          principalAddress.value.street == ''
            ? principalAddress.value.full
            : principalAddress.value.street,
        address_line_2: principalAddress.value.route,
        city_id: principalCity,
        state_id: principalState,
        country_id: principalCountry,
        zip_code: principalAddress.value.zip,
        google_address: principalAddress.value.full,
      };
    }
    // if (payloadPrincipalAddress && payloadPrincipalAddress.city_id === null) {
    //   showToast("Please enter valid valid postal address.", "error");
    //   return; // Stop execution if city_id is missing
    // }
    let bodyData = {};
    const basePayload = {
      trading_name: safeValue(tradingName.value),
      abn: safeValue(abn.value),
      acn: safeValue(acn.value),
      industry: safeValue(industry.value),
      website: safeValue(normalizeWebsite(companyWebsite.value)),

      contact_person_name: safeValue(agentName.value),
      contact_person_email: safeValue(email.value),
      contact_person_phone: safeValue(mobileNumber.value),

      profile_picture_file: profilePayloadFile.value
        ? {
            file_id: safeValue(profilePayloadFile.value.file_id),
            file_name: safeValue(profilePayloadFile.value.file_name),
          }
        : null,

      address: isValidAddress(payloadRegAddress) ? payloadRegAddress : null,

      postal_address: isValidAddress(payloadPrincipalAddress)
        ? payloadPrincipalAddress
        : null,

      is_submitted: isFinal ?? false,
    };
    if (roleName === 'business') {
      bodyData = {
        ...basePayload,
        business_name: safeValue(fullName.value),
        business_type: safeValue(companyTypeId),
      };
    }

    if (roleName === 'agency') {
      bodyData = {
        ...basePayload,
        agency_name: safeValue(fullName.value),
        agency_type: safeValue(companyTypeId),
      };
    }

    try {
      const response = await fetch(apiUrl, {
        method: isOnbaording ? 'POST' : 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] w-full max-w-full min-w-0 overflow-x-hidden">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed inset-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999] p-4">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[0].status == 'IN_REVIEW' ||
            stepStatus[0].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}

        {stepStatus.length > 0 && stepStatus[0].status == 'APPROVED' && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {/* FIX: the rejected-fields API returns the section under
               AGENCY_INFORMATION (agency role) — map it with readable
               labels, keeping BUSINESS_INFORMATION as fallback. */}
        {(rejectedFields?.AGENCY_INFORMATION?.rejected_fields?.length > 0 ||
          rejectedFields?.BUSINESS_INFORMATION?.rejected_fields?.length >
            0) && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {(rejectedFields.AGENCY_INFORMATION?.rejected_fields?.length ||
                0) +
                (rejectedFields.BUSINESS_INFORMATION?.rejected_fields?.length ||
                  0) ===
              1
                ? 'The following field requires correction:'
                : 'The following fields require correction:'}{' '}
            </p>

            <div className="flex flex-wrap gap-2">
              {(rejectedFields.AGENCY_INFORMATION?.rejected_fields || [])
                .concat(
                  rejectedFields.BUSINESS_INFORMATION?.rejected_fields || [],
                )
                .map((field) => (
                  <span
                    key={field}
                    className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                  >
                    {fieldLabelMap[field] || field.replace(/_/g, ' ')}
                  </span>
                ))}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="flex flex-wrap items-center border-b border-colour-custom gap-2 px-4 min-w-0">
            <img
              src="/briefcase.svg"
              alt="User Avatar"
              className="h-6 w-6 mb-2"
            />
            <h1 className="text-xl font-medium mb-2">
              {roleName == 'business'
                ? 'Business Information'
                : 'Business Information'}
            </h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r-0 border-gray-300">
              <div className="mb-2">
                <Dropdown
                  label={
                    <>
                      {roleName == 'business'
                        ? 'Businesss Type'
                        : 'Business Type'}
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  disabled={companyTypeId.status == 'approved'}
                  options={companyTypeData}
                  onSelect={handleSelectCompanyType}
                  preselectedValue={preSelectedCompanyType}
                  parentClass={
                    companyTypeId.status == 'rejected'
                      ? 'border-[#FF5050] border-2'
                      : ''
                  }
                />
              </div>
            </div>
          </div>
          <div className="bg-white">
            <div className="flex items-center border-b border-colour-custom space-x-2  pb-2"></div>

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
              {/* Profile Picture Section */}
              <div className="flex flex-col px-4 pt-4 border-r-0 lg:border-r border-gray-300">
                <LabelWithStatus
                  id="companyLogo"
                  label={fieldLabelMap.profile_picture}
                  required={false}
                  fieldData={profilePayloadFile}
                  handleStatusClick={handleStatusClick}
                />
                <div className="mt-1">
                  <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    PNG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    JPEG
                  </span>
                  <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                    &#60; 10 MB
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-16 h-16 flex items-center justify-center">
                    <img
                      src={preview}
                      alt="Avatar"
                      className={`${
                        profilePayloadFile.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } w-14 h-14 rounded-full`}
                    />
                  </div>
                  <div className="flex flex-col space-y-1">
                    <input
                      type="file"
                      accept="image/*"
                      className="hidden"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                    />
                    <button
                      onClick={handleUploadClick}
                      disabled={profilePayloadFile.status == 'approved'}
                      className={`${
                        profilePayloadFile.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : 'border-black border-2'
                      }
                          bg-white text-black text-xs px-3 py-1 rounded-full`}
                    >
                      Upload from Device
                    </button>
                  </div>
                </div>
                <div className="mt-4">
                  <LabelWithStatus
                    id="companyLogo"
                    label={fieldLabelMap.business_name}
                    required={true}
                    fieldData={fullName}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="fullName"
                    name="firstName"
                    type="text"
                    value={fullName?.value}
                    placeholder="Full Name"
                    disabled={fullName?.status == 'approved'}
                    className={`${
                      fullName?.status == 'rejected'
                        ? 'border-[#FF5050] border-2'
                        : ''
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setfullName({
                        ...fullName,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mt-4">
                  <LabelWithStatus
                    id="tradingName"
                    label={fieldLabelMap.trading_name}
                    required={true}
                    fieldData={tradingName}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="tradingName"
                    name="tradingName"
                    type="text"
                    value={tradingName.value}
                    placeholder="Enter trading name"
                    disabled={tradingName.status == 'approved'}
                    className={`${
                      tradingName.status == 'rejected'
                        ? 'border-[#FF5050] border-2'
                        : ''
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setTradingName({
                        ...tradingName,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="space-y-4 lg:pt-4 pt-0 border-r-0 lg:border-r border-gray-300 px-4 md:pl-0 pr-4">
                <div className="mt-4">
                  <LabelWithStatus
                    id="companyLogo"
                    label={fieldLabelMap.address}
                    required={true}
                    fieldData={registeredAddress}
                    handleStatusClick={handleStatusClick}
                  />
                  <AddressAutocomplete
                    value={
                      registeredAddress?.value?.full ||
                      registeredAddressApi?.google_address ||
                      ''
                    }
                    disabled={registeredAddress.status == 'approved'}
                    className={
                      registeredAddress.status == 'rejected'
                        ? 'border-[#FF5050] border-2 w-full'
                        : 'w-full'
                    }
                    onSelect={(addr) => {
                      setRegisteredAddressApi(null);
                      setRegisteredAddress({
                        ...registeredAddress,
                        value: addr,
                      });
                    }}
                  />
                </div>
                <div className="mt-4">
                  <LabelWithStatus
                    id="companyLogo"
                    label={fieldLabelMap.postal_address}
                    required={true}
                    fieldData={principalAddress}
                    handleStatusClick={handleStatusClick}
                  />
                  <AddressAutocomplete
                    value={
                      principalAddress?.value?.full ||
                      principalAddressApi?.google_address ||
                      ''
                    }
                    className={
                      principalAddress.status == 'rejected'
                        ? 'border-[#FF5050] border-2 w-full'
                        : 'w-full'
                    }
                    disabled={principalAddress.status == 'approved'}
                    onSelect={(addr) => {
                      setPrincipalAddressApi(null);
                      setPrincipalAddress({
                        ...principalAddress,
                        value: addr,
                      });
                    }}
                  />
                </div>
                <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                  Please make sure the provided address matches the document
                  proofs you provide.
                </p>
              </div>
              <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                <div className="">
                  <LabelWithStatus
                    id="companyLogo"
                    label={fieldLabelMap.abn}
                    required={true}
                    fieldData={abn}
                    handleStatusClick={handleStatusClick}
                  />
                  <div
                    className={`${
                      abn.status == 'rejected' || abnStatus === 'invalid'
                        ? 'border-[#FF5050] border-2'
                        : abnStatus === 'valid'
                          ? 'border-green-500 border-2'
                          : ''
                    }  flex items-center border px-2 rounded-lg w-full`}
                  >
                    <input
                      id="abn"
                      name="abn"
                      type="text"
                      inputMode="numeric"
                      value={abn.value}
                      placeholder="Enter ABN"
                      disabled={abn.status == 'approved'}
                      onBlur={validateAbn}
                      aria-invalid={abnStatus === 'invalid'}
                      aria-describedby="abn-message"
                      className={` h-[2.813rem] dark:focus-visible:ring-[#4E4E4E] dark:text-white text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none  w-full leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) => handleAbnChange(e.target.value)}
                    />
                    {abnStatus === 'checking' ? (
                      <span
                        className="material-symbols-outlined ml-2 text-xl text-gray-400 animate-spin"
                        aria-hidden="true"
                      >
                        progress_activity
                      </span>
                    ) : abnStatus === 'valid' || abnStatus === 'invalid' ? (
                      <span
                        className={`material-symbols-outlined ml-2 text-xl transition-all duration-300 scale-110 ${
                          abnStatus === 'valid'
                            ? 'text-green-500'
                            : 'text-red-500'
                        }`}
                        aria-hidden="true"
                      >
                        {abnStatus === 'valid' ? 'check_circle' : 'cancel'}
                      </span>
                    ) : null}
                  </div>
                  {/* Inline result: names the specific problem (format,
                      checksum or lookup) instead of waiting for submit. */}
                  {abnMessage && (
                    <p
                      id="abn-message"
                      role={abnStatus === 'invalid' ? 'alert' : 'status'}
                      aria-live="polite"
                      className={`text-[11px] mt-1 ${
                        abnStatus === 'valid'
                          ? 'text-green-600'
                          : abnStatus === 'invalid'
                            ? 'text-[#FF5050]'
                            : 'text-gray-500'
                      }`}
                    >
                      {abnMessage}
                    </p>
                  )}
                </div>
                <div className="mt-4">
                  <LabelWithStatus
                    id="companyLogo"
                    label={fieldLabelMap.acn}
                    required={true}
                    fieldData={acn}
                    handleStatusClick={handleStatusClick}
                  />
                  <div
                    className={`${
                      acn.status == 'rejected' || acnStatus === 'invalid'
                        ? 'border-[#FF5050] border-2'
                        : acnStatus === 'valid'
                          ? 'border-green-500 border-2'
                          : ''
                    }  flex items-center border px-2 rounded-lg w-full`}
                  >
                    <input
                      id="acn"
                      name="acn"
                      type="text"
                      inputMode="numeric"
                      value={acn.value}
                      placeholder="Enter ACN"
                      disabled={acn.status == 'approved'}
                      onBlur={validateAcn}
                      aria-invalid={acnStatus === 'invalid'}
                      aria-describedby="acn-message"
                      className={` h-[2.813rem] dark:focus-visible:ring-[#4E4E4E] dark:text-white text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none  w-full leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) => handleAcnChange(e.target.value)}
                    />
                    {acnStatus === 'checking' ? (
                      <span
                        className="material-symbols-outlined ml-2 text-xl text-gray-400 animate-spin"
                        aria-hidden="true"
                      >
                        progress_activity
                      </span>
                    ) : acnStatus === 'valid' || acnStatus === 'invalid' ? (
                      <span
                        className={`material-symbols-outlined ml-2 text-xl transition-all duration-300 scale-110 ${
                          acnStatus === 'valid'
                            ? 'text-green-500'
                            : 'text-red-500'
                        }`}
                        aria-hidden="true"
                      >
                        {acnStatus === 'valid' ? 'check_circle' : 'cancel'}
                      </span>
                    ) : null}
                  </div>
                  {/* Inline result: names the specific problem (format,
                      checksum or lookup) instead of waiting for submit. */}
                  {acnMessage && (
                    <p
                      id="acn-message"
                      role={acnStatus === 'invalid' ? 'alert' : 'status'}
                      aria-live="polite"
                      className={`text-[11px] mt-1 ${
                        acnStatus === 'valid'
                          ? 'text-green-600'
                          : acnStatus === 'invalid'
                            ? 'text-[#FF5050]'
                            : 'text-gray-500'
                      }`}
                    >
                      {acnMessage}
                    </p>
                  )}
                </div>
                <div className="mt-4">
                  <LabelWithStatus
                    id="companyWebsite"
                    label={fieldLabelMap.website}
                    required={true}
                    fieldData={companyWebsite}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="companyWebsite"
                    name="companyWebsite"
                    type="text"
                    inputMode="url"
                    autoComplete="url"
                    value={companyWebsite.value ?? ''}
                    placeholder="example.com.au"
                    disabled={companyWebsite.status == 'approved'}
                    aria-invalid={websiteStatus === 'invalid'}
                    aria-describedby="website-message"
                    onBlur={handleWebsiteBlur}
                    className={`${
                      companyWebsite.status == 'rejected' ||
                      websiteStatus === 'invalid'
                        ? 'border-[#FF5050] border-2'
                        : ''
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) => handleWebsiteChange(e.target.value)}
                  />
                  {websiteMessage && (
                    <p
                      id="website-message"
                      role="alert"
                      className="text-[11px] mt-1 text-[#FF5050]"
                    >
                      {websiteMessage}
                    </p>
                  )}
                </div>
                <div className="mt-4">
                  <LabelWithStatus
                    id="industry"
                    label={fieldLabelMap.industry}
                    required={true}
                    fieldData={industry}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="industry"
                    name="industry"
                    type="text"
                    value={industry.value}
                    placeholder="Enter industry"
                    disabled={industry.status == 'approved'}
                    className={`${
                      industry.status == 'rejected'
                        ? 'border-[#FF5050] border-2'
                        : ''
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setIndustry({
                        ...industry,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white shadow-md rounded-md p-4 mb-4 mt-4">
          <div className="flex flex-wrap items-center border-b border-colour-custom gap-2 px-4 min-w-0">
            <h1 className="text-xl font-medium mb-2">Contact Person Details</h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
            <div className="flex flex-col px-4 pt-4 border-r-0 lg:border-r border-gray-300">
              <div className="">
                <LabelWithStatus
                  id="agentName"
                  label="Full Name"
                  required={true}
                  fieldData={agentName}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  id="agentName"
                  name="agentName"
                  type="text"
                  value={agentName.value}
                  placeholder="Enter name"
                  disabled={agentName.status == 'approved'}
                  className={`${
                    agentName.status == 'rejected'
                      ? 'border-[#FF5050] border-2'
                      : ''
                  } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                  onChange={(e) =>
                    setAgentName({
                      ...agentName,
                      value: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="space-y-4 lg:pt-4 pt-0 border-r-0  border-gray-300 px-4 md:pl-0 pr-4">
              <div className="">
                <LabelWithStatus
                  id="email"
                  label="Email"
                  required={true}
                  fieldData={email}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  id="agentName"
                  name="agentName"
                  type="text"
                  value={email.value}
                  placeholder="Enter email"
                  disabled={email.status == 'approved'}
                  className={`${
                    email.status == 'rejected'
                      ? 'border-[#FF5050] border-2'
                      : ''
                  } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                  onChange={(e) =>
                    setEmail({
                      ...email,
                      value: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
              <div className="">
                <LabelWithStatus
                  id="mobileNumber"
                  label="Mobile Number"
                  required={true}
                  fieldData={mobileNumber}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  id="mobileNumber"
                  name="mobileNumber"
                  type="text"
                  value={mobileNumber.value}
                  placeholder="Enter Mobile Number"
                  disabled={mobileNumber.status == 'approved'}
                  className={`${
                    mobileNumber.status == 'rejected'
                      ? 'border-[#FF5050] border-2'
                      : ''
                  } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                  onChange={(e) =>
                    setMobileNumber({
                      ...mobileNumber,
                      value: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row gap-3 md:gap-4 p-3 sm:p-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:pb-4 bg-[#375AE7] sticky bottom-0 z-20 md:static w-full">
        {stepStatus.length > 0 &&
          stepStatus[0].status != 'COMPLETED' &&
          stepStatus[0].status != 'APPROVED' &&
          stepStatus[0].status != 'IN_REVIEW' && (
            <>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-start w-full gap-2 sm:gap-3 relative">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={true}
                  isBack={false}
                  onBack={handleBack}
                />
              </div>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end w-full gap-2 sm:gap-3 md:gap-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    handleContinue(false);
                  }}
                  className="flex w-full sm:w-auto min-h-[44px] items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Save as Draft</span>
                </button>

                <ConfirmContinueButton
                  onContinue={() => handleContinue(true)}
                  buttonText="Continue"
                  confirmTitle="Save Section"
                  confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                />
              </div>
            </>
          )}
        {stepStatus.length > 0 &&
          (stepStatus[0].status == 'COMPLETED' ||
            stepStatus[0].status == 'APPROVED' ||
            stepStatus[0].status == 'IN_REVIEW') && (
            <>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-start w-full gap-2 sm:gap-3 relative">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={false}
                  isBack={false}
                  onBack={handleBack}
                />
              </div>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end w-full gap-2 sm:gap-3 md:gap-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    setCurrentStep(2);
                  }}
                  className="flex w-full sm:w-auto min-h-[44px] items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Next</span>
                </button>
              </div>
            </>
          )}
      </footer>
    </div>
  );
};

export default BusinessUserInfo;
